// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__bzKrl","clickable":"Card_clickable__w9yMt","loading":"Card_loading__tHKN7"};